import React, {ReactNode, ReactNodeArray} from 'react';
import EpiComponent from '@episerver/spa-core/EpiComponent';
import GenericGuideSubTitleBlockData from '../../../Models/Content/GenericGuideSubTitleBlockData';
import GenericGuideSubTitle from './GenericGuideSubTitleBlock';

export default class GenericGuideSubTitleBlock extends EpiComponent<GenericGuideSubTitleBlockData> {
  public render(): ReactNode | ReactNodeArray | null {
    let cssClasses: Array<string> = ['generic-guide-sub-title-block'];

    return (
      <div className={cssClasses.join(" ")}>
            <GenericGuideSubTitle iContent={this.props.data} context={this.getContext()} />
      </div>
    )
  }
}

